import React from "react";
const AuthContext = new React.createContext(null);
export default AuthContext;